import { html, LitElement } from 'lit-element';

import { latexToHTML } from '../headerBlocks/utils.js';

/**
 * @element response-modal-math-inline
 * @prop {Object} response - Response
 */
export class ResponseModalMathInline extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData } = this.response || {};
    const { completeAnswer } = sessionData || {};

    return html`<div>
      <div class="modal-response-content">
        <div class="modal-response-content-row">
          <math-rendering-element
            .label="${completeAnswer
              ? latexToHTML(completeAnswer)
              : 'Empty response'}"
          ></math-rendering-element>
        </div>
      </div>
    </div>`;
  }
}

export default ResponseModalMathInline;
